<template>
  <DashboardWidget canGoFullscreen title="Analisi degli indicatori" class="analisi-indicatori-widget no-overflow" dialog-class="modal--type-dashboard-widget modal--type-dashboard-widget-analisi-indicatori">
    <OperativeTable dense>
      <OperativeTableHeader align="center" :years="values.years || []"/>
      <tbody>
      <OperativeTableBodyRowKpi align="center" hide-label :values="values.scoringStrutturaFinanziaria || []">Scoring struttura finanziaria</OperativeTableBodyRowKpi>
      <OperativeTableBodyRowKpi align="center" hide-label :values="values.scoringCicloFinanziario || []">Scoring ciclo finanziario</OperativeTableBodyRowKpi>
      <OperativeTableBodyRowKpi align="center" hide-label :values="values.scoringAndamentoEconomico || []">Scoring andamento economico</OperativeTableBodyRowKpi>
      <OperativeTableBodyRowKpi align="center" hide-label :values="values.scoringLeverage || []">Scoring leverage</OperativeTableBodyRowKpi>
      <OperativeTableBodyRowKpi align="center" hide-label :values="values.scoringEquilibrioStrutturaAziendale || []">Scoring equilibrio della struttura aziendale</OperativeTableBodyRowKpi>
      <OperativeTableBodyRowKpiZScore align="center" hide-label :values="values.zScore || []">Z-Score</OperativeTableBodyRowKpiZScore>
      <OperativeTableBodyRowKpiRating align="center" hide-label :values="values.rating || []">Rating</OperativeTableBodyRowKpiRating>
      </tbody>
    </OperativeTable>

    <template #fullscreen>
      <OperativeTable dense>
        <OperativeTableHeader align="center" :years="values.years || []"/>
        <tbody>
        <OperativeTableBodyRowKpi align="center" hide-label :values="values.scoringStrutturaFinanziaria || []">Scoring struttura finanziaria</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi align="center" hide-label :values="values.scoringCicloFinanziario || []">Scoring ciclo finanziario</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi align="center" hide-label :values="values.scoringAndamentoEconomico || []">Scoring andamento economico</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi align="center" hide-label :values="values.scoringLeverage || []">Scoring leverage</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpi align="center" hide-label :values="values.scoringEquilibrioStrutturaAziendale || []">Scoring equilibrio della struttura aziendale</OperativeTableBodyRowKpi>
        <OperativeTableBodyRowKpiZScore align="center" hide-label :values="values.zScore || []">Z-Score</OperativeTableBodyRowKpiZScore>
        <OperativeTableBodyRowKpiRating align="center" hide-label :values="values.rating || []">Rating</OperativeTableBodyRowKpiRating>
        </tbody>
      </OperativeTable>
    </template>
  </DashboardWidget>
</template>

<script>

export default {
  name: 'dashboard-widget-kpi',
  components: {
    DashboardWidget: () => import('./DashboardWidget'),
    OperativeTable: () => import('../../Operative/OperativeTable'),
    OperativeTableBodyRowKpi: () => import('../../Operative/Kpi/OperativeTableBodyRowKpi'),
    OperativeTableBodyRowKpiZScore: () => import('../../Operative/Kpi/OperativeTableBodyRowKpiZScore'),
    OperativeTableBodyRowKpiRating: () => import('../../Operative/Kpi/OperativeTableBodyRowKpiRating'),
    OperativeTableHeader: () => import('../../Operative/OperativeTableHeader'),
  },
  props: {
    values: {
      type: Object,
      default: () => ({}),
    },
  },
};

</script>

<style lang="scss">

.modal--type-dashboard-widget-analisi-indicatori {
  max-width: 80%;
  max-height: 80vh;
}

</style>
